import { Injectable } from '@angular/core';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { LoginService } from './login.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsService {
AutoIndex=null
startDate:Date
endDate:Date
duration:number
examType

  constructor(private http:HttpClient, public ls :LoginService) { }

  

 addEvent(appointment) {
    const visitId = Number(sessionStorage.getItem("visit_id") || 0) || undefined;
    return this.http.post("/api/appointment", { ...appointment, apptVisitSourceId: visitId });
  }


  async fetchEvents(startDate, endDate): Promise<any> {
    try {
      const start = startDate.split('T')[0]; // Format as YYYY-MM-DD
      const end = endDate.split('T')[0];
      const data = await this.http.get('api/appointment', {
        params: {
          "UID": this.ls.doctor,
          "start": start,
          "end": end
        }
      }).toPromise();
      return data;
    } catch (error) {
      console.error('Error fetching events:', error);
      throw error;
    }
  }
  
  searchAvailableSlots(data){
    return this.http.post('api/appointment/slots',data)
  }

  calculateDuration(startDate: Date, endDate: Date): number {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const duration = endMoment.diff(startMoment);
    const durationInMinutes = moment.duration(duration).asMinutes();

    return durationInMinutes;
  }

  setAppointment({AutoIndex,aptlength,aptTime,examType,PID}){
  this.AutoIndex=AutoIndex
  this.duration=aptlength
  this.startDate=new Date(aptTime);
  this.examType=examType
  this.endDate=null
  }


  async delete(AutoIndex, GID): Promise<boolean> {
    try {
      const visitId = Number(sessionStorage.getItem("visit_id") || 0) || undefined;
      const opts = visitId ? { params: { visitId: String(visitId) } } : {};

      await this.http.delete(`/api/appointment/${AutoIndex}/${GID}`, opts).toPromise();
      return true;
    } catch (error) {
      console.error("Error deleting event:", error);
      throw error;
    }
  }

  

  async getAppointment(AutoIndex: string): Promise<boolean> {
    try {
      const params = new HttpParams().set('AutoIndex', AutoIndex);
  
      const result = await this.http.get(`/api/appointment/byId`, { params }).toPromise();
      
      return result['appointment'];
    } catch (error) {
      console.error('Error fetching appointment:', error);
      throw error;
    }
  }
  
  async updateAppointment(appointment): Promise<any> {
    if (appointment.AutoIndex == null) {
      throw new Error("AutoIndex is not set.");
    }
    const visitId = Number(sessionStorage.getItem("visit_id") || 0) || undefined;

    try {
      return this.http
        .put("/api/appointment", { ...appointment, apptVisitSourceId: visitId })
        .toPromise();
    } catch (error) {
      console.error("Error update event:", error);
      throw error;
    }
  }

  
private resetService() {
  this.AutoIndex = null;
  this.startDate = null;
  this.endDate = null;
  this.duration = null;
  this.examType = null;
}


appointmentHour(Date) {
  const startDate =Date;
  if (startDate) {
    const hours = startDate.getHours().toString().padStart(2, "0");
    const minutes = startDate.getMinutes();
   const startHour = `${hours}:${minutes.toString().padStart(2, "0")}`; 
    return startHour
  }
}

async arrived(appointmentId,PID,value){
  return this.http.put(`/api/appointment/arrived`,{appointmentId,PID,value}).toPromise(); 
}


calcAppointmentPrice(appointment){
  return this.http.post('/api/appointment/Price',appointment)
}
}
